import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { canManagePromoCodes } from '@manaro/contracts'
import { useSession } from '@/features/auth/use-session.ts'
import { LimitsDialog } from '@/features/promo-codes/components/limits-dialog.tsx'
import { PromoCodeView } from '@/features/promo-codes/components/promo-code-view.tsx'
import { usePromoCode } from '@/features/promo-codes/use-promo-codes.ts'
import { ApiError } from '@/shared/api/client.ts'
import { Card } from '@/shared/ui/card.tsx'
import { ErrorState, Skeleton } from '@/shared/ui/states.tsx'

export function PromoCodePage() {
  const { id = '' } = useParams()
  const promoId = Number(id)
  const promo = usePromoCode(promoId)
  const access = useSession().data?.user.access
  const mayManage = access !== undefined && canManagePromoCodes(access)
  const [editing, setEditing] = useState(false)

  const valid = Number.isInteger(promoId) && promoId > 0

  return (
    <>
      <Link
        to="/promo-codes"
        className="mb-4 inline-flex items-center gap-1.5 text-[13.5px] text-ink-muted transition-colors hover:text-ink max-md:-mt-3 max-md:mb-1 max-md:py-3"
      >
        <ArrowLeft className="size-4" aria-hidden />
        Промокоды
      </Link>

      {!valid ? (
        <Card>
          <ErrorState message="Промокод не найден — вернитесь к списку." />
        </Card>
      ) : promo.isPending ? (
        <div className="flex flex-col gap-3.5">
          <Skeleton className="h-9 w-64" />
          <Skeleton className="h-5 w-80" />
          <Skeleton className="h-[96px] rounded-card" />
          <Skeleton className="h-[240px] rounded-card" />
        </div>
      ) : promo.error ? (
        <Card>
          <ErrorState
            message={promo.error instanceof ApiError ? promo.error.message : 'Не удалось открыть промокод.'}
            onRetry={promo.error instanceof ApiError && promo.error.status === 404 ? undefined : () => void promo.refetch()}
          />
        </Card>
      ) : (
        <PromoCodeView promo={promo.data} canManage={mayManage} onEditLimits={() => setEditing(true)} />
      )}

      {editing && promo.data && <LimitsDialog promo={promo.data} onClose={() => setEditing(false)} />}
    </>
  )
}
